import type { AiRecommendationJourney } from '@cobliteam/hooks/src/useAiRecommendationsStore/useAiRecommendationsStore';
import { useLocation } from 'react-router-dom';
import { getJourneysForLocation } from './useAiRecommendationCta';

/**
 * Returns the journey IDs whose target page matches the current route.
 * Empty array means the current page has no contextual journey mapping —
 * callers should fall back to global recommendation behavior.
 */
export const useContextualJourneyIds = (): AiRecommendationJourney[] => {
  const { pathname } = useLocation();
  return getJourneysForLocation(pathname);
};
